import { useEffect, useState } from 'react';
import { fileUploadApiKeyStore } from '../../../../api/file-upload-key-store';
import { useFileDownload } from '../../../../components/file-download';
import { SiTrackGrid } from '../../../../components/si-track-grid/si-track-grid';
import { UserPermissionName } from '../../../../models/user-permission-name';
import { columns } from './grid-columns';
import { gridApiKeyStore } from '../../../../api/grid-api-key-store';
import { useLoadData } from '../../../../hooks/useLoadData';
import { ApiResponse } from '../../../../models/api-response';
import { GridColumnConfig, GridPreference } from '../../../../models/gridCoumnConfig';
import { unitsApiKeyStore } from '../../../../api/units-api-key-store';
import { FileObject } from '../../../../models/fileUpload';
import { useSaveData } from '../../../../hooks/useSaveData';
import useDebounce from '../../../../hooks/use-debounce';
import { State } from '@progress/kendo-data-query';

interface FilesTab {
  customerID: number;
}
export const FilesTab = ({ customerID }: FilesTab) => {
  const { error, downloadFile, isLoading } = useFileDownload();
  const handleDownloadFile = async (data: any) => {
    downloadFile({ additionalData: data });
  };

  // -------------------------------------------------Grid Layout------------------------------

  const {
    isLoading: isLoadingGridLayout,
    data: gridLayouts,
    refetch: refetchGridLayout,
  } = useLoadData<ApiResponse<GridPreference>>(gridApiKeyStore.getGridLayout('Customer Details', 'File'));

  const {
    isLoading: isLoadingFile,
    data: files,
    refetch,
  } = useLoadData<ApiResponse<FileObject[]>>(fileUploadApiKeyStore.getFiles({ customerID: customerID }));

  const { mutateAsync } = useSaveData<any>(gridApiKeyStore.saveGridLayOut());
  const [gridConfig, setGridConfig] = useState<{
    dataState: State | undefined;
    columns: any[] | undefined;
  }>();

  const [filteredFiles, setFilteredFiles] = useState<FileObject[]>([]);

  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearchTerm = useDebounce(searchTerm, 300);

  useEffect(() => {
    const filteredFileList = files?.data?.filter((file) =>
      Object.values(file).some(
        (value) => value && value.toString().toLowerCase().includes(debouncedSearchTerm.toLowerCase())
      )
    );
    setFilteredFiles(filteredFileList || []);
  }, [debouncedSearchTerm, files?.data]);

  const handleInputChange = (value: string) => {
    setSearchTerm(value);
  };

  const handleSaveLayout = (gridDataState: State, gridColumns: GridColumnConfig[]) => {
    const data = {
      filterJSON: JSON.stringify(gridDataState),
      columnJSON: JSON.stringify(gridColumns),
      gridName: 'File',
      pageName: 'Customer Details',
    };

    mutateAsync({ data }).then(() => {
      refetchGridLayout();
    });
  };

  const handleResetLayout = () => {
    const data = {
      filterJSON: null,
      columnJSON: null,
      gridName: 'File',
      pageName: 'Customer Details',
    };

    mutateAsync({ data }).then(() => {
      refetchGridLayout();
    });
  };

  useEffect(() => {
    if (!gridLayouts?.data) return;

    try {
      const filterData = gridLayouts.data.filterJSON ? JSON.parse(gridLayouts.data.filterJSON) : null;

      const columnJson = gridLayouts.data.columnJSON ? JSON.parse(gridLayouts.data.columnJSON) : null;

      // if (filterData && columnJson) {
      setGridConfig({
        columns: columnJson,
        dataState: filterData,
      });
      // }
    } catch (error) {
      console.log('Error parsing grid layout JSON:', error);
    }
  }, [gridLayouts?.data]);

  return (
    <SiTrackGrid
      fileTitle='customer_file'
      dataItemKey="fileID"
      columns={columns}
      // queryConfig={fileUploadApiKeyStore.getFiles({ customerID: customerID })}
      onDownload={(data: any) => {
        handleDownloadFile(data);
      }}
      actionPermissions={{ download: UserPermissionName.DOWNLOAD_FILE, export: UserPermissionName.DOWNLOAD_GRID }}
      isBusy={isLoading}
      // -----------------Grid Layout-------
      dataItems={filteredFiles || []}
      reorderable
      handleSearch={handleInputChange}
      handleSaveLayout={handleSaveLayout}
      isSaveLayout={true}
      gridConfigFromApi={gridConfig}
      handleResetLayout={handleResetLayout}
    // -----------------Grid Layout-------
    />
  );
};
